import { z } from "zod";

export const exchangeCodeSchema = z.object({
	code: z.uuid(),
});

export type ExchangeCodePayload = z.infer<typeof exchangeCodeSchema>;

export const createExchangeCodeSchema = z.object({
	refresh_token: z.string().min(1),
});

export type CreateExchangeCodePayload = z.infer<typeof createExchangeCodeSchema>;
